import React, { useState } from 'react';
import { BarChart3 } from 'lucide-react';
import RelatoriosVisaoGeral from '../components/relatorios/RelatoriosVisaoGeral';
import RelatorioCustoDeslocamento from '../components/relatorios/RelatorioCustoDeslocamento';

const Relatorios = () => {
  const [activeTab, setActiveTab] = useState('visao_geral');

  return (
    <div className="space-y-6 animate-fade-in" data-testid="relatorios-page">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center">
            <BarChart3 className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-slate-900">Relatórios</h1>
            <p className="text-slate-600">Análise de custos e performance</p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-sm p-2">
        <div className="inline-flex w-full md:w-auto bg-slate-100 rounded-xl p-1">
          <button
            type="button"
            onClick={() => setActiveTab('visao_geral')}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              activeTab === 'visao_geral'
                ? 'bg-white text-slate-900 shadow-sm'
                : 'text-slate-600 hover:text-slate-900'
            }`}
          >
            Visão geral
          </button>
          <button
            type="button"
            onClick={() => setActiveTab('custo_deslocamento')}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              activeTab === 'custo_deslocamento'
                ? 'bg-white text-slate-900 shadow-sm'
                : 'text-slate-600 hover:text-slate-900'
            }`}
          >
            Custo de deslocamento
          </button>
        </div>
      </div>

      {activeTab === 'visao_geral' ? <RelatoriosVisaoGeral /> : <RelatorioCustoDeslocamento />}
    </div>
  );
};

export default Relatorios;
